import { InjectionToken, NgModule, inject, provideAppInitializer } from '@angular/core';
// import {
//     MSAL_CONFIG,
//     MSAL_CONFIG_ANGULAR,
//     MsalAngularConfiguration
//     , MsalService, MsalModule, MsalInterceptor
// } from '@azure/msal-angular';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ConfigLoaderService } from '../app/Shared/Services/Config/config-loader.service'
import { Configuration } from 'msal';


import { PreloadFactory,initializerFactory,MSALInstanceFactory,MSALInterceptorConfigFactory,MSALGuardConfigFactory} from './Shared/FactoryService/preload-service.factory'
//import {CustomMsalInterceptor} from './CustomMsalInterceptor'
import { IPublicClientApplication, PublicClientApplication, InteractionType } from '@azure/msal-browser';
import { MsalGuard, MsalInterceptor, MsalBroadcastService, MsalInterceptorConfiguration,
     MsalModule, MsalService, MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, 
     MsalGuardConfiguration, MsalRedirectComponent ,} from '@azure/msal-angular';



const AUTH_CONFIG_URL_TOKEN = new InjectionToken<string>('AUTH_CONFIG_URL');


@NgModule({
    providers: [
    ],
    imports: [MsalModule]
})


  
export class MsalApplicationModule {

    static forRoot(configFile: string) {
        return {
            ngModule: MsalApplicationModule,
            providers: [
                ConfigLoaderService,    
                { provide: AUTH_CONFIG_URL_TOKEN, useValue: configFile },   
                // {
                //     provide: APP_INITIALIZER,
                //     useFactory: PreloadFactory,
                //     deps: [ConfigLoaderService,AUTH_CONFIG_URL_TOKEN],
                    
                // },         
                provideAppInitializer(() => {
        const initializerFn = (initializerFactory)(inject(ConfigLoaderService), inject(AUTH_CONFIG_URL_TOKEN));
        return initializerFn();
      }),
                {
                    provide: MSAL_INSTANCE,
                    useFactory: MSALInstanceFactory,
                    deps: [ConfigLoaderService]
                },
                {
                    provide: MSAL_GUARD_CONFIG,
                    useFactory: MSALGuardConfigFactory,
                    deps: [ConfigLoaderService]
                },
                {
                    provide: MSAL_INTERCEPTOR_CONFIG,
                    useFactory: MSALInterceptorConfigFactory,
                    deps: [ConfigLoaderService]
                },
                MsalService,
                {
                    provide: HTTP_INTERCEPTORS,
                useClass: MsalInterceptor,
                 //useClass: CustomMsalInterceptor,
                    multi: true
                }
            ]
        };
    }
}
